import loadGoogleMapsApi from "load-google-maps-api";

let channel = null;
if (process.env.RAILS_ENV !== "production") {
  channel = 100;
}

export default loadGoogleMapsApi({ key: GOOGLEMAP_KEY, v: 3, channel: channel });
